import { render, staticRenderFns } from "./CargoColegiadoEdit.vue?vue&type=template&id=7f9f24cc&scoped=true&"
import script from "./CargoColegiadoEdit.vue?vue&type=script&lang=js&"
export * from "./CargoColegiadoEdit.vue?vue&type=script&lang=js&"
import style0 from "./CargoColegiadoEdit.vue?vue&type=style&index=0&id=7f9f24cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9f24cc",
  null
  
)

export default component.exports